import { Student } from "@/types/generated/DifcamWebTypes";

import { BaseService } from "./BaseService";

export class StudentService extends BaseService {
  getStudent(): Promise<Student> {
    return this.get<Student>("/student");
  }
}
